module.exports = __webpack_public_path__ + "static/media/IconCustomAddMargin.826b8ce0.svg";